import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditBankPayment = () => {
    const { id } = useParams(); // Get the bank payment ID from the URL params
    const [staffId, setStaffId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [amount, setAmount] = useState('');
    const [description, setDescription] = useState('');
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    // Fetch the existing bank payment details when the component mounts
    useEffect(() => {               
        fetch(`${BASE_URL}bankpayment/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const { staff_id, c_id, amount, description } = data.data;
                    setStaffId(staff_id);
                    setCustomerId(c_id);
                    setAmount(amount);
                    setDescription(description);
                } else {
                    setMessage('Error fetching bank payment details');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                setMessage('Error fetching bank payment details');
            });
    }, [id]);

    // Handle form input changes
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'staffId') {
            setStaffId(value);
        } else if (name === 'customerId') {
            setCustomerId(value);
        } else if (name === 'amount') {
            setAmount(value);
        } else if (name === 'description') {
            setDescription(value);
        }
    };

    // Handle form submission to update bank payment entry
    const handleSubmit = (event) => {
        event.preventDefault();

        const data = {
            staff_id: staffId,
            c_id: customerId,
            amount: amount,
            description: description,
        };

        fetch(`${BASE_URL}bankpayment/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setMessage(data.message);
                    // Optionally navigate to the bank payment list after successful submission
                    setTimeout(() => {
                        navigate('/BankPaymentList');
                    }, 2000);
                } else {
                    setMessage('Error updating bank payment entry.');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                setMessage('Error updating bank payment entry.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Bank Payment Entry</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form start */}
            <section className="section">
                <div className="row" id="basic-form">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Bank Payment</h4>
                            </div>
                            <div className="card-body">
                                {message && <div className="alert alert-info">{message}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="staffId" className="form-label">Staff ID</label>
                                        <input
                                            type="text"
                                            id="staffId"
                                            name="staffId"
                                            className="form-control"
                                            placeholder="Enter Staff ID"
                                            value={staffId}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="customerId" className="form-label">Customer ID</label>
                                        <input
                                            type="text"
                                            id="customerId"
                                            name="customerId"
                                            className="form-control"
                                            placeholder="Enter Customer ID"
                                            value={customerId}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            id="amount"
                                            name="amount"
                                            className="form-control"
                                            placeholder="Enter Amount"
                                            value={amount}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            name="description"
                                            className="form-control"
                                            placeholder="Enter Description"
                                            value={description}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Form end */}
        </div>
    );
};

export default EditBankPayment;
